import Lottie, { LottieRefCurrentProps } from 'lottie-light-react';
import React, { useRef } from 'react';
import coverPendingAnimationData from '../../animations/article_cover_pending.json';
import Media from '../../Components/Media';
import { Article } from '../../Types/Article';

interface ArticleCoverProps {
  article: Article;
}

const ArticleCover: React.FC<ArticleCoverProps> = ({ article }) => {
  const coverImageLottieRef = useRef<LottieRefCurrentProps>();

  const hasVideo = !!article.coverVideo?.url;
  const hasImage = !!(
    article.coverImage?.coverUrl ||
    article.coverImage?.compressedUrl ||
    article.coverImage?.originalUrl
  );

  const renderContent = () => {
    if (hasVideo || hasImage) {
      return (
        <Media
          src={
            [
              article.coverVideo?.url,
              article.coverImage?.coverUrl,
              article.coverImage?.compressedUrl,
              article.coverImage?.originalUrl,
              require('../../assets/article-cover-pending.png'),
            ].filter(Boolean) as string[]
          }
          alt={article.title}
          isActive={true}
          className={`!w-full ${hasVideo ? '!h-auto' : 'h-[355px]'}
          object-cover overflow-hidden rounded-xl
          max-sm:h-[200px] max-sm:rounded-none`}
          loader={<div className={'w-full h-[355px]'}></div>}
        />
      );
    } else {
      return (
        <Lottie
          lottieRef={coverImageLottieRef}
          animationData={coverPendingAnimationData}
          title="Your image is coming right up..."
          loop={true}
          onDOMLoaded={() => {
            // Unfortunately, no way to do it declaratively with 'lottie-light-react'
            coverImageLottieRef.current?.setSpeed(0.7);
          }}
          className={`w-full h-[355px] object-cover overflow-hidden rounded-xl
          max-sm:h-[200px]`}
        />
      );
    }
  };

  return <div className="relative">{renderContent()}</div>;
};

export default ArticleCover;
